var cartInitInterval;
var cartContainer = null;

export const initCart = () => {
    if (document.body.classList.contains("woocommerce-cart")) {
        setTimeout(function () {
            alterCart();
            //moveCouponSection();
        }, 500);

        cartInitInterval = setInterval(function () {
            checkInitCardModifiers();
        }, 200);
        checkInitCardModifiers();
    }
};

const checkInitCardModifiers = () => {
    cartContainer = document.querySelector(".wc-block-cart");
    if (cartContainer !== null) {
        clearInterval(cartInitInterval);
        initCardModifiers();
    }
};

const initCardModifiers = () => {
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                if (
                    mutation.target.classList.contains(
                        "wc-block-cart-item__total-price-and-sale-badge-wrapper",
                    )
                ) {
                    alterCart();
                    //moveCouponSection();
                }
            }
        }
    });

    // Start observing the cart container for changes
    if (cartContainer) {
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
};

const alterCart = () => {
    if (document.querySelector(".wc-block-components-button__text")) {
        document.querySelector(".wc-block-components-button__text").innerHTML =
            bm_variables.cart_checkout_button;
    }

    if (document.querySelector(".wc-block-components-totals-coupon button")) {
        document.querySelector(
            ".wc-block-components-totals-coupon button",
        ).childNodes[1].nodeValue = bm_variables.add_coupon_text;
    }

    document.querySelectorAll(".wc-block-cart-items__row").forEach((row) => {
        const badges = row.querySelectorAll(".wc-block-components-sale-badge");

        if (badges.length) {
            if (badges.length > 1) {
                badges[0].style.display = "none";
            } else {
                badges[0].style.display = "block";
            }
        }
    });
};

// this is killing the fixed checkout button on mobile
const moveCouponSection = () => {
    const couponSection = document.querySelector(
        ".wp-block-woocommerce-cart-order-summary-coupon-form-block",
    );

    if (couponSection) {
        document
            .querySelector(".wc-block-cart__submit-container")
            .after(couponSection);
    }
};
